module.exports = __webpack_public_path__ + "img/footer-logo5.4590e733.png";